function normalizeCriteriaChipsUi(result) {
  if (!result || typeof result !== 'object') return null

  var ui = result.criteriaUi || result.criteriaUI || result.criteriaChips || null
  if (!ui || typeof ui !== 'object') return null
  if (String(ui.type || '').toLowerCase() !== 'criteria-chips') return null

  var chips = Array.isArray(ui.chips) ? ui.chips : []
  if (!chips.length && ui.status !== 'no_exact_match' && !ui.request) return null

  return {
    title: ui.title || '',
    instruction: ui.instruction || '',
    status: ui.status || '',
    request: ui.request || '',
    unresolvedTerms: Array.isArray(ui.unresolvedTerms) ? ui.unresolvedTerms.map(function (term) { return String(term || '').trim() }).filter(Boolean) : [],
    radarRunId: normalizeRadarRunId(ui),
    chips: chips.map(function (chip) {
      if (typeof chip === 'string') {
        return { label: chip }
      }
      return {
        label: chip.label || '',
        sourceText: chip.sourceText || '',
        field: chip.field || '',
        operator: chip.operator || '',
        value: chip.value,
        action: chip.action && typeof chip.action === 'object' ? chip.action : null,
        branchOperator: chip.branchOperator || '',
        chunkOperator: chip.chunkOperator || '',
        groupOperator: chip.groupOperator || ''
      }
    }).filter(function (chip) {
      return chip.label
    })
  }
}

function renderCriteriaChipsUi(criteriaUi) {
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  var chips = criteriaUi.chips || []
  var terms = criteriaUi.unresolvedTerms || []
  var request = criteriaUi.request || ''
  var showTitle = criteriaUi.status !== 'no_exact_match'

  return (
    '<div class="wc-criteria-ui">' +
      (showTitle && criteriaUi.title ? '<div class="wc-criteria-title">' + escapeHtml(criteriaUi.title) + '</div>' : '') +
      (request ? '<div class="wc-criteria-request"><span>Demande conservée :</span> ' + escapeHtml(request) + '</div>' : '') +
      (terms.length ? '<div class="wc-criteria-terms"><span>Termes à préciser :</span> ' + terms.map(function (term) { return '<code>' + escapeHtml(term) + '</code>' }).join(' ') + '</div>' : '') +
      '<div class="wc-criteria-chip-list">' +
        chips.map(function (chip, index) {
          var branch = chip.branchOperator ? '<span class="wc-criteria-branch-operator">' + escapeHtml(formatLogicalOperator(chip.branchOperator)) + '</span>' : ''
          var group = chip.groupOperator ? '<span class="wc-criteria-chip-operator">' + escapeHtml(formatLogicalOperator(chip.groupOperator)) + '</span>' : ''
          var source = chip.sourceText ? '<small>' + escapeHtml(chip.sourceText) + '</small>' : ''
          var chipContent = group + '<span>' + escapeHtml(chip.label) + '</span>' + source
          return branch + (chip.action
            ? '<button type="button" class="wc-criteria-chip wc-criteria-chip-action" data-criteria-chip-index="' + index + '">' + chipContent + '</button>'
            : '<span class="wc-criteria-chip">' + chipContent + '</span>')
        }).join('') +
      '</div>' +
      (criteriaUi.instruction ? '<div class="wc-criteria-instruction">' + escapeHtml(criteriaUi.instruction) + '</div>' : '') +
    '</div>'
  )
}

function bindCriteriaChipsUi(el, criteriaUi, handlers) {
  if (!el || !criteriaUi || !handlers || typeof handlers.onSelect !== 'function') return
  Array.prototype.slice.call(el.querySelectorAll('[data-criteria-chip-index]')).forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return
      var index = Number(button.getAttribute('data-criteria-chip-index') || -1)
      var chip = criteriaUi.chips[index]
      if (!chip || !chip.action) return
      button.disabled = true
      handlers.onSelect(chip)
    })
  })
}

function normalizeRadarRunId(ui) {
  return ui && typeof ui.radarRunId === 'string' ? ui.radarRunId : ''
}

function escapeAttribute(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function formatLogicalOperator(operator) {
  if (operator === 'OR') return 'OU'
  if (operator === 'AND') return 'ET'
  return operator
}

export { bindCriteriaChipsUi, normalizeCriteriaChipsUi, renderCriteriaChipsUi }
